import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { COMMA, ENTER, V } from '@angular/cdk/keycodes';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { MatExpansionPanel } from '@angular/material/expansion';
import { MatAutocomplete, MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import { MatMenuTrigger } from '@angular/material/menu';

import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import {  Subject, Subscription, takeUntil } from 'rxjs';
import { CommonService } from '../services/common.service';
import { LoginService } from '../login/login.service';
import { ToastrService } from 'ngx-toastr';
import { W700servicesService } from '../services/w700services.service';
import { LocationStrategy } from '@angular/common';
import { isNullOrEmpty } from 'src/Utility/StringValidation';
import { AppConfigService } from '../configurations/app-config.service';
import { TabChangeService } from '../services/tab-change.service';

declare var $
declare var window: any;
@Component({ selector: 'app-homepage', templateUrl: './homepage.component.html', styleUrls: ['./homepage.component.scss'] })
export class HomepageComponent implements OnInit {
  protected apiURL: string = AppConfigService.settings.WebApiURL;
  private destroy$ = new Subject<void>();
  private defaultKey = 'passport';
  @ViewChild(MatMenuTrigger, { static: false }) trigger: MatMenuTrigger;
  // Template ref for header role menu — used to recalculate overlay position after open
  @ViewChild('roleMenuTrigger', { static: false }) roleMenuTrigger: MatMenuTrigger;
  public reactiveOrganization: FormGroup;
  public reactiveAccount: FormGroup;
  userActivity;
  userInactive: Subject<any> = new Subject();
  Organizations = <any>[];
  Accounts = <any>[];
  CaseTypes = [];
  keywordsearch_Organization = "OrganizationName";
  keywordsearch_Account = "Account";
  keywordsearch_CaseType = "CaseType";
  keywordsearch_Deployment = "Deployment";
  OrganizationID: number = 0;
  AccountID: number = 0;
  CaseType: string = "";
  dropdownList = [];
  selectedItems = [];
  dropdownSettingsforcasetype = {};
  dropdownSettingsforaoe = {};
  OrderCode: string = "";
  selectedCaseType = [];
  selectedAoeType: any[] = [];
  OptionalAOE: boolean = true;
  Deployment: string = "";
  ctrlAccounts = new FormControl();
  isVendor = "Compendium";
  AOE = "";
  ctrlOrganization: string = "";
  usernamedisplay: any;
  timezoneList: string[] = ['UTC', 'IST', 'EST'];

  aoelist: any[] = [
    "Jars",
    "Services",
    "Collection Method",
    "Sites",
    "Clinical History",
    "Bill To",
    "Rule Outs"
  ];
  pagerolepermisions: any;
  isLoadingResult: boolean = false;
  isLoadingResultAccount: boolean = false;
  visible = true;
  selectable = true;
  removable = true;
  addOnBlur = true;
  separatorKeysCodes: number[] = [ENTER, COMMA];
  caseTypeCtrl = new FormControl();

  @ViewChild('caseInput', { static: false }) caseInput: ElementRef<HTMLInputElement>;
  @ViewChild('auto', { static: false }) matAutocomplete: MatAutocomplete;
  @ViewChild('myPanel', { static: false }) myPanel: MatExpansionPanel;
  CompendiumAccount: string;
  compendiumaoe: string;
  menus: any;
  SelectedUser = "";
  selectedTimezone: string = this.service.getTimezoneForDisplay();
  menusList: any;
  menusArray = [];
  leftmenus: any[];
  browserRefresh;
  previousUrl: any;
  isRefreshed: boolean;
  issso:boolean = false;
      servicesso: boolean = false;
  servicessostatussub: Subscription;
  subscription: Subscription;
  subscriptionroutes: Subscription;
    bLogin: boolean = true;
  isShow: boolean;
  private originalBackdropWidth: string = '';
  private originalBackdropLeft: string = '';
  private originalBackdropHeight: string = '';
  private originalBackdropTop: string = '';
  classw700: string = '';
  classw700flag: boolean = false;
  Compendium: ICompendium | undefined;
  selectedTabIndex: number = 0;
  selectedComponents:any[]=[];
  indexnum:number=0
  screenHeight = window.innerHeight;
  displaymessage: boolean = false;
  routeId:string='';
  createsubtab:any;
  msgsubtab:any;
  vendint:any;
  caseint:any;
  msgcase:any;
  verdorlist = [
    'Compendium',
    'Raw',
    'AllScripts',
    'eCW',
    'GMed',
    'Vanadis'
  ];
  rolemenupermissionlst:Rolepermissionslst[]= [];
  errorMessage: string = "User does not have the required access to proceed further. Kindly reach out to vahubteam@vitalaxis.com Team for assistance."
  constructor(
    private location: LocationStrategy,
    private router: Router,
    private route: ActivatedRoute,
    private toastr: ToastrService,
    private LoginService: LoginService,
    private _fb: FormBuilder,
    private loginService: LoginService,
    private ngxUiLoaderService: NgxUiLoaderService, private service: CommonService, public Service: W700servicesService, private tabChangeService: TabChangeService) {
    this.reactiveOrganization = this._fb.group({ orgname: '' });
    this.reactiveAccount = this._fb.group({ accname: '' });
    this.userInactive.subscribe(() => {
      clearTimeout(this.userActivity);
      this.ngxUiLoaderService.stopAll();
      window.history.forward()
      this.nobackbutton()
      $('#screenlock').modal({ backdrop: 'static', keyboard: false });
    });
    this.route.queryParams
      .subscribe(async params => {
        let input = params['Input'];
        const encryptId = params['EncryptId'] || params['EncryptID'];
        if (!isNullOrEmpty(input)) {
          let encryptValue = `Input=${input}`;
          if (!isNullOrEmpty(encryptId)) {
            encryptValue += `&EncryptID=${encryptId}`;
          }
          sessionStorage.setItem('ssoinput', JSON.stringify(encryptValue))
          await this.getpermission();
        }
      }
      );
  }

  async getpermission() {
      
    const postentity: any = {
      "Encryptvalue": JSON.parse(sessionStorage.getItem("ssoinput")),
    }
    var datares = await this.loginService.getrolesdatapost('api/UserRoleConfig/SaveOrGetSSOUser', postentity)
     

      if (datares!=null) {
        sessionStorage.setItem('SelectedUserRole', datares["RoleName"]);
        var sessionObject = {
          userdata: {
            FormattedDisplayName: datares["UserID"],
            userid: datares["UserID"]
          }
        }
         if(sessionStorage.getItem("SelectedUserRole")=='LabAdminCase360' || sessionStorage.getItem("SelectedUserRole").toLowerCase()=='admin3'){
          this.issso=true;
         }
        sessionStorage.setItem('sessionObjectlogin', JSON.stringify(sessionObject));

        const newRolePermission: Rolepermissionslst = {
          PrimaryRoleId: datares["PrimaryRoleId"],
          RoleID: datares["RoleID"],
          RoleName: datares["RoleName"],
          UserID: datares["UserID"],
          ftpDetailId: datares["ftpDetailId"],
          menuslist: datares["menuslist"],
          uniqueId: datares["uniqueId"]
        };
        this.rolemenupermissionlst.push(newRolePermission);
        sessionStorage.setItem('rolewithmenus', JSON.stringify(this.rolemenupermissionlst));

        if (!this.issso) {
          this.SelectedMenus(datares.menuslist.find(x=>x.IsDefaultMenu==true).MenuDisplayName,false);
        }
        
      }
 
  }

  ngOnInit() {

    this.servicessostatussub = this.service.servicessostatus.subscribe((data) => {
      if (data) {
        this.servicesso = true;
      } else {
        this.servicesso = false;
      }
    });
    this.createsubtab=this.service.pipelineName$
    .pipe(takeUntil(this.destroy$))
    .subscribe((id:string)=>{
      if(typeof(id)=='string'){
      this.routeId=id;
      if(!isNullOrEmpty(this.routeId)){
        this.SelectedMenus('create',false);
        this.service.setPipelineName_2(id);
    }
  }
    });
    this.msgsubtab=this.service.message$
    .pipe(takeUntil(this.destroy$))
    .subscribe((data:any)=>{
      if (!isNullOrEmpty(data) && !isNullOrEmpty(data.id)) {
        this.routeId = data.id;
        this.SelectedMenus('messages',false);
      }
    });
    this.vendint=this.service.vendorinterface$
    .pipe(takeUntil(this.destroy$))
    .subscribe((data:any)=>{
      if(!isNullOrEmpty(data)){
        this.SelectedMenus('interface',false);
      }
    })
    this.caseint=this.service.case360interface$
    .pipe(takeUntil(this.destroy$))
    .subscribe((data:any)=>{
      if(!isNullOrEmpty(data)){
        this.SelectedMenus('interface',false);
        this.service.setcaseintObj_2(data);
      }
    })
    this.msgcase=this.service.msgtocase360$
    .pipe(takeUntil(this.destroy$))
    .subscribe((data:any)=>{
      if(!isNullOrEmpty(data)){
        this.SelectedMenus('case 360 prime',false);
          this.service.setmsgcaseObj_2(data);
      }
    })
    this.service.openMenuTab$
      .pipe(takeUntil(this.destroy$))
      .subscribe((menuName: string) => {
        if (!isNullOrEmpty(menuName)) {
          this.SelectedMenus(menuName, false);
        }
      });
    if(this.routeId==null || this.routeId=='')
    {
      const existingSessionObject = JSON.parse(sessionStorage.getItem('sessionObjectlogin'));
      const existingRoleWithMenus = JSON.parse(sessionStorage.getItem('rolewithmenus'));
      if (!isNullOrEmpty(existingSessionObject) && (existingRoleWithMenus ? existingRoleWithMenus.length > 0 : false)) {
        this.isRefreshed = history.state.navigationId == 1 ? true : false;
        this.refresh();
      } else {
        this.ngxUiLoaderService.start();

        var UserName = '';
        this.LoginService.getUserInfo().subscribe({
          next: (data) => {
            if (isNullOrEmpty(data)) {

              this.ngxUiLoaderService.stopAll();
              this.router.navigate(['/login']);
            }
            else {
              UserName = data.email;
              if (UserName.includes('starmarkit.com')) {
                UserName = UserName.replace('starmarkit.com', 'starmark.com')
              }

              var sessionObject1 = {
                userdata: {
                  FormattedDisplayName: UserName,
                  userid: UserName
                }
              }
              sessionStorage.setItem('sessionObjectlogin', JSON.stringify(sessionObject1));
              this.isRefreshed = history.state.navigationId == 1 ? true : false;
              var sessionObject = JSON.parse(sessionStorage.getItem('sessionObjectlogin'));
              if (!isNullOrEmpty(sessionObject)) {
                this.loginService.getrolesdata('api/UserRoleConfig/GetUserRoleConfig?UserId=' + sessionObject.userdata['FormattedDisplayName']).subscribe(data => {
                  if (data ? data.length > 0 : false) {
                    this.displaymessage = false;
                    sessionStorage.setItem('rolewithmenus', JSON.stringify(data))
                    const rolename = data.find(x => x.PrimaryRoleId == true).RoleName;
                    sessionStorage.setItem('SelectedUserRole', rolename);
                    let defaultmenu = data.find(x => x.RoleName == rolename)
                    const defaultmenuobj = defaultmenu.menuslist.find(z => z.IsDefaultMenu == true) ? defaultmenu.menuslist.find(z => z.IsDefaultMenu == true) : '';
                    if (defaultmenuobj.MenuName == '' || defaultmenuobj.MenuName == undefined) {
                      this.SelectedMenus('try it out',false);
                    } else {
                      var urls = '/home/' + defaultmenuobj.MenuName;
                      this.refresh();
                      this.SelectedMenus(defaultmenuobj.MenuDisplayName,false);
                    }
                    
                    // Show timezone notification on first login
                    this.showTimezoneNotification();
                    
                    this.ngxUiLoaderService.stopAll()
                  } else {
                    this.displaymessage = true;
                    this.ngxUiLoaderService.stopAll()
                  }
                }, erro => {
                  this.toastr.error(erro.statusText, "Failed", {
                    timeOut: 4000,
                    positionClass: 'toast-bottom-right'
                  });
                  this.service.copyableToastError(erro.statusText);
                  this.ngxUiLoaderService.stopAll();
                })
              }
              else {
                this.ngxUiLoaderService.stopAll()
                this.router.navigate(['/login']);
              }
            }
          },
          error: error => {

            this.ngxUiLoaderService.stopAll();
            this.router.navigate(['/login']);
          }
        });
      }
    }
  this.routeId=null
  }
  refresh() {
    this.subscription = this.service.currentMessage.subscribe(message => {
      if (message) {
        this.ngxUiLoaderService.stopAll();
        this.lockscreen();
      } else {
        $('#screenlock').modal('hide');
      }
    });

    var sessionObject = JSON.parse(sessionStorage.getItem('sessionObjectlogin'));
    if (!isNullOrEmpty(sessionObject)) {

      let name = sessionObject.userdata['FormattedDisplayName']
      this.usernamedisplay = name.split('@')[0].replaceAll('.', ' ')

      this.menusList = JSON.parse(sessionStorage.getItem('rolewithmenus'));
      if (this.menusList.length > 0) {
        let isbackuproles = JSON.parse(JSON.stringify(this.menusList))
        for (var i = 0; i < isbackuproles.length; i++) {
          let ar = this.uniqmenuarray(isbackuproles[i].menuslist)
          if (ar.length > 0) {
            isbackuproles[i].menuslist = ar
          }
        }
        this.menusArray = isbackuproles
        if (this.menusArray.length > 0) {
          if (sessionStorage.getItem('SelectedUserRole') == (this.menusArray.find(x => x.PrimaryRoleId == true).RoleName) && JSON.parse(sessionStorage.getItem("selectedRole")) == null) {
            this.SelectRole(this.menusArray.find(x => x.PrimaryRoleId == true), false);
          }
          else {
            this.SelectRole(JSON.parse(sessionStorage.getItem("selectedRole")), false);
          }
        }
      }
    }
  }
  collapseMenu() {
    this.myPanel.accordion.closeAll();
    this.myPanel.expanded = true

  }
  SelectRole(value, isflag) {
    this.SelectedUser = value.RoleName;
    sessionStorage.setItem('SelectedUserRole', this.SelectedUser);
    sessionStorage.setItem('selectedRole', JSON.stringify(value))
    this.leftmenus = []
    let uniqrole = this.menusArray.filter(va => va.RoleName === value.RoleName)
    if (uniqrole.length > 0) {
      this.leftmenus = uniqrole[0].menuslist
      if (this.leftmenus.length > 0) {
        this.leftmenus = this.sortByKey(this.leftmenus, "MenuOrder")
        let defaultsroute = this.leftmenus.filter(va => va.IsDefaultMenu == true)
        if (defaultsroute.length == 0) {
          for (let i = 0; i < this.leftmenus.length; i++) {
            if (this.leftmenus[i].submenu) {
              defaultsroute = this.leftmenus[i].submenu.filter(va => va.IsDefaultMenu == true);
              if (defaultsroute.length > 0) {
                break;
              }
            }
          }
        }
        this.isRefreshed = false;
        if (defaultsroute.length > 0) {
          this.ngxUiLoaderService.start();
          this.selectedComponents=[];
          this.indexnum=0;
          this.SelectedMenus(defaultsroute[0].MenuDisplayName,false);
          this.ngxUiLoaderService.stop();
          }
        else {
          this.toastr.warning('Selected Role default menu mapping unavailable', "", {
            timeOut: 4000,
            positionClass: 'toast-bottom-right'
          });

          setTimeout(() => {
            this.loginService.logout();
          }, 3000);

        }
      }
    }
  }



  uniqmenuarray(array) {
    if (array !== undefined) {
      let main = []
      if (array.length > 0) {
        for (var i = 0; i < array.length; i++) {
          main = array.filter(va => va.MenuType == "Main")
          if (main.length > 0) {
            for (let i = 0; i < main.length; i++) {
              let arry = array.filter(va => va.ParentMenuId === main[i].MenuId && va.MenuType == "SubMain")
              if (arry.length > 0) {
                main[i]['submenu'] = arry
                for (let j = 0; j < arry.length; j++) {
                  let ind = array.findIndex(va => va.MenuName === arry[j].MenuName)
                  array.splice(ind, 1);
                }
              }
            }
            return main
          }
        }
      }
    }
  }

  sortByKey(array, key) {
    return array.sort(function (a, b) {
      var x = a[key]; var y = b[key];
      return ((x < y) ? -1 : ((x > y) ? 1 : 0));
    });
  }


  nobackbutton() {
    history.pushState(null, null, window.location.href);
    this.location.onPopState(() => {
      history.pushState(null, null, window.location.href);
    })
  }
  ngOnDestroy() {
    this.destroy$.next();
    if (!isNullOrEmpty(this.subscription)&& !isNullOrEmpty(this.userInactive)) {
      this.subscription.unsubscribe();
      this.userInactive.unsubscribe();
    }
  }

  logout() {
      this.LoginService.logout();
      this.service.changeMessage(false);
  }

  lockscreen() {
    this.nobackbutton()

    $('#screenlock').modal({ backdrop: 'static', keyboard: false });
    setTimeout(() => { // this.lockpassword.nativeElement.select();
    }, 0);
  }

  UnlockUser() {

    var sessionObject = JSON.parse(sessionStorage.getItem('sessionObjectlogin'));

    let loginval = {
      UserName: sessionObject.userdata['userid']
    }
    if (!isNullOrEmpty(loginval.UserName)) {
      this.ngxUiLoaderService.start();
      this.LoginService.RefreshToken().subscribe({
        next: async data => {
          $('#screenlock').modal('hide');
          this.ngxUiLoaderService.stopAll()
        },
        error: error => {
          this.ngxUiLoaderService.stopAll()
        }
      });
    }
  }

  loadPrerequisites() {
    this.dropdownSettingsforcasetype = {
      singleSelection: false,
      idField: 'CaseType',
      textField: 'CaseTypeDisplayName',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 6,
      allowSearchFilter: true
    };

    this.dropdownSettingsforaoe = {
      singleSelection: false,
      idField: 'AoeDetails',
      textField: 'AoeName',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 6,
      allowSearchFilter: true
    }


  }
  openMyMenu() {
    this.trigger.toggleMenu();
  }
  closeMyMenu() {
    this.trigger.closeMenu();
  }
  /** Recalculate role dropdown position after open (fixes left-side misalignment on some tabs). */
  onRoleMenuOpened() {
    setTimeout(() => {
      if (this.roleMenuTrigger) {
        this.roleMenuTrigger.updatePosition();
      }
    }, 0);
  }
  onCaseTypeSelect(item: any) {
    this.selectedCaseType.push(item.CaseType);
  }
  onCaseTypeSelectAll(items: any) {
    for (var i = 0; i < items.length; i++) {
      this.selectedCaseType.push(items[i].CaseType);
    }

  }
  onaoeSelect(item: any) {
    this.selectedAoeType.push(item.AoeDetails);
  }
  onaoeSelectAll(items: any) {
    for (var i = 0; i < items.length; i++) {
      this.selectedAoeType.push(items[i].AoeDetails);
    }

  }

  onCaseTypeDeSelect(item: any) {
    this.selectedCaseType = this.selectedCaseType.filter(x => x != item)
  }
  onaoeDeSelect(item: any) {
    this.selectedAoeType = this.selectedAoeType.filter(x => x != item)
  }
  onCaseTypeDeSelectAll(items: any) {
    this.selectedCaseType = [];
  }
  onaoeDeSelectAll(items: any) {
    this.selectedAoeType = [];
  }


  async getOrganization(input: any) {
    this.Accounts = [];
    this.CaseTypes = [];
    if (input.length < 3) {
      return;
    }
 

    if (this.Validate() == false) {
      return;
    }
    var urlterm = "api/Compendium/GetOrganizations?OrganizationName=" + input;
    this.isLoadingResult = true;
    this.Service.getapi(urlterm, this.Deployment.toLowerCase()).subscribe(data => {
      if (data) {
        this.Organizations = data as any[];
      }
    })
    this.isLoadingResult = false;
  }

  getOrganizationName(input: any) { }

  async getAccounts(input: any) {

    this.OrganizationID = input.OrganizationID;
    this.AccountID = 0;
    this.CaseType = "";


    this.CaseTypes = [];
    if (this.Validate() == false) {
      return;
    }
    var urlterm = "api/Compendium/GetAccounts?OrganizationID=" + this.OrganizationID;
    this.isLoadingResultAccount = true;
    this.Service.getapi(urlterm, this.Deployment.toLowerCase()).subscribe(data => {
      if (data) {
        this.Accounts = data as any[];
      }
    })
    this.isLoadingResultAccount = false;
  }

  async getCaseTypes(input: any) {
    this.AccountID = input.value;

    var urlterm = "api/Compendium/GetCaseTypes?LabOrgID=" + this.OrganizationID + "&LabAccountID=" + this.AccountID;

    if (this.Validate() == false) {
      return;
    }
    this.Service.getapi(urlterm, this.Deployment.toLowerCase()).subscribe(data => {
      if (data) {
        let obj = {
          CaseType: "All",
          OrderCode: "All",
          CaseTypeDisplayName: "All"
        }
        data.length > 0 ? data.unshift(obj) : data;
        this.CaseTypes = data as any[];
      }
    })
  }

  searchOrganizationCleared(input: any) {
    this.Accounts = [];
    this.CaseTypes = [];
  }

  searchAccountsCleared(input: any) {
    this.CaseTypes = [];
  }

  GetOptionalAOE(input: any) {
    this.OptionalAOE = input.value;
  }

  Validate() {
    if (this.Deployment == "" || this.Deployment == 'Deployment') {
      this.toastr.warning('Choose a deployment ', "", {
        timeOut: 4000,
        positionClass: 'toast-bottom-right'
      });
      return false;
    }
    return true;
  }

  GetCompendium() {
    let caseTypesValue = "";
    if (this.selectedCaseType.length > 0) {
      let exists = this.selectedCaseType.filter(va => va === 'All');
      if (exists.length > 0 && this.CaseTypes.length > 0) {
        for (let i = 0; i < this.CaseTypes.length; i++) {
          if (this.CaseTypes[i].CaseType !== 'All' && i > 0 && i < this.CaseTypes.length - 1) {
            caseTypesValue += this.CaseTypes[i].CaseType + ",";
          } else if (this.CaseTypes[i].CaseType !== 'All') {
            caseTypesValue += this.CaseTypes[i].CaseType;
          }
        }
      } else {
        caseTypesValue = this.selectedCaseType.join(',')
      }
    }


    this.Compendium = {
      OrganizationID: this.OrganizationID,
      AccountID: this.AccountID,
      CaseType: caseTypesValue,
      OptionalAOE: this.OptionalAOE,
      OrganizationName: "",
      Vendor: this.isVendor,
      AOEs: this.selectedAoeType.join(',')
    }

    if (this.Validate() == false) {
      return;
    }
    var urlterm = "api/Compendium/GetCompendium?OrganizationID=" + this.OrganizationID + "&AccountID=" + this.AccountID + "&CaseType=" + caseTypesValue + "&OptionalAOE=" + this.OptionalAOE + "&Vendor=" + this.isVendor;

    if (this.Validate() == false) {
      return;
    }
    this.ngxUiLoaderService.start();
    this.Service.getCompendiumExcel(urlterm, this.Deployment.toLowerCase()).subscribe((file) => {
      if (file) {
        const source = `data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,${file.body['FileContents']
          }`;
        const link = document.createElement("a");
        link.href = source;
        link.download = "Compendium_" + Date.now().toString() + ".xlsx";
        link.click();
        this.ngxUiLoaderService.stop();
        this.toastr.success('Compedium downloaded successfully', "", {
          timeOut: 500,
          positionClass: 'toast-bottom-right'
        });
        $('#exampleModal').modal('hide');

      }

    })
  }

  OnDeploymentChange(input: any) {
    if (this.Deployment == input.value) {
      return;
    }
    this.ctrlAccounts.setValue('');
    this.Deployment = input.value;
    this.Organizations = [];
    this.Accounts = [];
    this.CaseTypes = [];
  }
  OnisVendorChange(input: any) {
    this.isVendor = input.target.value;
  }

  OnAOEChange(input: any) {
    this.AOE = input.target.value;
  }

  getDeployment(input: any) { }

  openCompendium() {
    this.clear();
    $('#exampleModal').appendTo("body").modal('show', {
      backdrop: 'static',
      keyboard: false
    });
  }
  clear() {
    this.Deployment = '';
    this.CaseTypes = [];
    this.selectedCaseType = [];
    this.CompendiumAccount = "";
    this.compendiumaoe = "";
    this.caseTypeCtrl.setValue('')
    this.Accounts = [];
    this.Organizations = [];
    this.isVendor = "";
    this.reactiveOrganization.reset();
    this.reactiveAccount.reset();
  }


  remove(casetype: string): void {
    const index = this.selectedCaseType.indexOf(casetype);
    if (index >= 0) {
      this.selectedCaseType.splice(index, 1);
    }
  }

  selected(event: MatAutocompleteSelectedEvent): void {

    if (event.option.viewValue == 'All') {
      this.selectedCaseType = []
    }
    if (this.selectedCaseType.length > 0) {
      let exists = this.selectedCaseType.filter(va => va === 'All');
      if (exists.length > 0) {
        this.toastr.warning(exists[0] + " " + "option includes every casetype for the lab account", "", {
          timeOut: 4000,
          positionClass: 'toast-bottom-right'
        });
        this.caseInput.nativeElement.value = '';
        this.caseTypeCtrl.setValue(null);
        this.caseInput.nativeElement.blur();
      } else {
        let exist = this.selectedCaseType.filter(va => va === event.option.viewValue);
        if (exist.length > 0) {
          this.toastr.warning(exist[0] + " " + 'Already Exist', "", {
            timeOut: 4000,
            positionClass: 'toast-bottom-right'
          });
        } else {
          this.selectedCaseType.push(event.option.viewValue);
          this.caseInput.nativeElement.value = '';
          this.caseTypeCtrl.setValue(null);
          this.caseInput.nativeElement.blur();
        }
      }
    } else {
      this.selectedCaseType.push(event.option.viewValue);
      this.caseInput.nativeElement.value = '';
      this.caseTypeCtrl.setValue(null);
      this.caseInput.nativeElement.blur();
    }
  }

  SelectedMenus(menuname:string,ishtml:boolean){
  let ispresent =this.selectedComponents.length>0?this.selectedComponents.find(V=>V.displayname.toLowerCase() ===menuname.toLowerCase()):[];
  if(isNullOrEmpty(ispresent) || isNullOrEmpty(ispresent)){
    let obj={
      id:this.indexnum,
      displayname:menuname
    };
    this.selectedComponents.push(obj);
    this.getComponent(menuname);
    ishtml?this.selectedTabIndex=this.selectedComponents.length-1:this.selectedTabIndex=this.indexnum;
    // Emit tab change when selecting a new menu
    this.tabChangeService.emitTabChange(menuname);
    this.indexnum++;
  }
  else{
    this.selectedTabIndex=ispresent.id;
    // Emit tab change when switching to existing tab
    this.tabChangeService.emitTabChange(menuname);
    if(ishtml){
    this.toastr.warning('Tab Already Exist', "", {
      timeOut: 4000,
      positionClass: 'toast-bottom-right'
    });
  }
  }
  }
  getComponent(Menuname: string): any {
   let component= this.service.Getcomponentbyname(Menuname);
   if(component!=''&&component!=undefined&&component!=null){
    return component
   }
   else{
    this.toastr.warning('Error Occured', "", {
      timeOut: 4000,
      positionClass: 'toast-bottom-right'
    });
    return '';
   }
  }
  
  // Handle tab changes from mat-tab-group
  onTabChanged(event: any) {
    const newTabIndex = event.index;
    const activeComponent = this.selectedComponents[newTabIndex];
    if (activeComponent) {
      this.tabChangeService.emitTabChange(activeComponent.displayname);
    }
    this.selectedTabIndex = newTabIndex;
  }
  
  onSidenavMouseEnter() {
    this.isShow = true;
    // Adjust ALL modal backdrops to make room for expanded side nav
    const backdrops = document.querySelectorAll('.modal-backdrop.show') as NodeListOf<HTMLElement>;
    
    setTimeout(() => {
      // Get actual viewport dimensions
      const viewportWidth = window.innerWidth;
      const viewportHeight = window.innerHeight;
      
      // Get sidenav element to calculate its actual width
      const sidenav = document.querySelector('mat-sidenav') as HTMLElement;
      const sidenavWidth = sidenav ? sidenav.getBoundingClientRect().width : 0;
      
      // Calculate backdrop dimensions dynamically
      // Get actual header height from the header element
      const headerElement = document.querySelector('.row.white') as HTMLElement;
      const headerHeight = headerElement ? headerElement.getBoundingClientRect().height : 60;
      
      // Calculate bottom padding dynamically: 2% of viewport height, but between 20px and 40px
      // This ensures consistent spacing across different screen resolutions
      const bottomPadding = Math.min(40, Math.max(20, viewportHeight * 0.02));
      const backdropHeight = viewportHeight - headerHeight - bottomPadding;
      
      // Calculate gap/spacing dynamically: 2.5% of viewport width, but between 30px and 60px
      // This ensures consistent spacing between sidenav and backdrop across different screen resolutions
      const sidenavGap = Math.min(60, Math.max(30, viewportWidth * 0.025));
      
      // Calculate overlap compensation dynamically: 0.1% of viewport width, but between 8px and 15px
      // This prevents backdrop from overlapping the sidenav and scales proportionally with screen size
      const overlapCompensation = Math.min(15, Math.max(8, viewportWidth * 0.001));
      const backdropLeft = sidenavWidth + sidenavGap + overlapCompensation;
      const backdropWidth = viewportWidth - sidenavWidth - sidenavGap - overlapCompensation;
      
      // Loop through ALL backdrops (parent and nested)
      backdrops.forEach((backdrop, index) => {
        backdrop?.classList.add('adjusted-backdrop');
        
        if (backdrop) {
          // Store original values if not already stored (only for first backdrop to avoid duplicates)
          if (index === 0 && !this.originalBackdropWidth) {
            const computedStyle = window.getComputedStyle(backdrop);
            this.originalBackdropWidth = computedStyle.width || backdrop.style.width || `${viewportWidth * 0.95}px`;
            this.originalBackdropLeft = computedStyle.left || backdrop.style.left || `${viewportWidth * 0.045}px`;
            // Store the actual computed height (not the calculated backdropHeight)
            this.originalBackdropHeight = computedStyle.height || backdrop.style.height || '';
            // Preserve the exact top position - only store if backdrop already has a top value set
            // Don't set top if it wasn't originally set, to avoid changing the position
            const currentTopStyle = backdrop.style.top;
            const computedTop = computedStyle.top;
            // Only store if we have a valid top value that was explicitly set (not 'auto' or empty)
            if (currentTopStyle && currentTopStyle.trim() !== '' && currentTopStyle !== 'auto') {
              this.originalBackdropTop = currentTopStyle;
            } else if (computedTop && computedTop !== 'auto' && computedTop !== '0px' && computedTop !== '') {
              // Only use computed top if it's a meaningful value (not default)
              this.originalBackdropTop = computedTop;
            }
            // If no top is set, don't store anything - we'll leave it unchanged
          }
          
          // Adjust backdrop position for ALL backdrops using calculated values
          // Keep the original top position (don't change it) - only set if we have a stored value
          backdrop.style.width = `${backdropWidth}px`;
          backdrop.style.left = `${backdropLeft}px`;
          backdrop.style.height = `${backdropHeight}px`;
          // Only set top if we have a stored original value to preserve exact position
          if (this.originalBackdropTop) {
            backdrop.style.top = this.originalBackdropTop;
          }
        }
      });
      
      // Adjust ALL CDK overlay backdrops
      const cdkBackdrops = document.querySelectorAll('.cdk-overlay-backdrop') as NodeListOf<HTMLElement>;
      cdkBackdrops.forEach(cdkBackdrop => {
        if (cdkBackdrop) {
          // Preserve the current top position, don't change it - only set if we have a stored value
          cdkBackdrop.style.setProperty('width', `${backdropWidth}px`, 'important');
          cdkBackdrop.style.setProperty('left', `${backdropLeft}px`, 'important');
          cdkBackdrop.style.setProperty('height', `${backdropHeight}px`, 'important');
          // Only set top if we have a stored original value to preserve exact position
          if (this.originalBackdropTop) {
            cdkBackdrop.style.setProperty('top', this.originalBackdropTop, 'important');
          }
        }
      });
      
      // Also adjust modals to match backdrop dimensions
      const modals = document.querySelectorAll('.modal.show') as NodeListOf<HTMLElement>;
      modals.forEach(modal => {
        // Exclude templatemodaladd and other modals with data-template-modal attribute
        if (modal && !modal.classList.contains('templatemodaladd') && !modal.hasAttribute('data-template-modal')) {
          // Preserve the current top position, don't change it - only set if we have a stored value
          modal.style.left = `${backdropLeft}px`;
          modal.style.width = `${backdropWidth}px`;
          modal.style.height = `${backdropHeight}px`;
          // Only set top if we have a stored original value to preserve exact position
          if (this.originalBackdropTop) {
            modal.style.top = this.originalBackdropTop;
          }
        }
      });
    }, 120);
  }

  onSidenavMouseLeave() {
    this.isShow = false;
    
    // Get actual viewport dimensions for restoration
    const viewportWidth = window.innerWidth;
    const viewportHeight = window.innerHeight;
    // Get actual header height from the header element
    const headerElement = document.querySelector('.row.white') as HTMLElement;
    const headerHeight = headerElement ? headerElement.getBoundingClientRect().height : 60;
    const backdropHeight = viewportHeight - headerHeight;
    
    // Restore ALL modal backdrops to original position
    const backdrops = document.querySelectorAll('.modal-backdrop.show') as NodeListOf<HTMLElement>;
    
    backdrops.forEach((backdrop, index) => {
      if (backdrop) {
        if (this.originalBackdropWidth) {
          // Restore original values for all backdrops (including original height and top)
          backdrop.style.width = this.originalBackdropWidth;
          backdrop.style.left = this.originalBackdropLeft;
          // Restore original height if stored, otherwise remove it to let CSS handle it
          if (this.originalBackdropHeight) {
            backdrop.style.height = this.originalBackdropHeight;
          } else {
            backdrop.style.removeProperty('height');
          }
          // Restore original top if stored, otherwise remove it to let CSS handle it
          if (this.originalBackdropTop) {
            backdrop.style.top = this.originalBackdropTop;
          } else {
            backdrop.style.removeProperty('top');
          }
        } else {
          // Fallback: calculate default values if originals weren't stored
          const defaultWidth = viewportWidth * 0.95;
          const defaultLeft = viewportWidth * 0.045;
          backdrop.style.width = `${defaultWidth}px`;
          backdrop.style.left = `${defaultLeft}px`;
          backdrop.style.removeProperty('height');
          backdrop.style.removeProperty('top');
        }
      }
    });
    
    // Restore ALL CDK overlay backdrops
    const cdkBackdrops = document.querySelectorAll('.cdk-overlay-backdrop') as NodeListOf<HTMLElement>;
    cdkBackdrops.forEach(cdkBackdrop => {
      if (cdkBackdrop) {
        if (this.originalBackdropWidth) {
          // Restore original values
          cdkBackdrop.style.setProperty('width', this.originalBackdropWidth, 'important');
          cdkBackdrop.style.setProperty('left', this.originalBackdropLeft, 'important');
          // Restore original height if stored
          if (this.originalBackdropHeight) {
            cdkBackdrop.style.setProperty('height', this.originalBackdropHeight, 'important');
          } else {
            cdkBackdrop.style.removeProperty('height');
          }
          // Restore original top if stored
          if (this.originalBackdropTop) {
            cdkBackdrop.style.setProperty('top', this.originalBackdropTop, 'important');
          } else {
            cdkBackdrop.style.removeProperty('top');
          }
        } else {
          // Fallback: calculate default values if originals weren't stored
          const defaultWidth = viewportWidth * 0.94;
          const defaultLeft = viewportWidth * 0.05;
          cdkBackdrop.style.setProperty('width', `${defaultWidth}px`, 'important');
          cdkBackdrop.style.setProperty('left', `${defaultLeft}px`, 'important');
          cdkBackdrop.style.setProperty('height', `${backdropHeight}px`, 'important');
          cdkBackdrop.style.setProperty('top', `${headerHeight}px`, 'important');
        }
      }
    });
    
    // Also restore modals
    const modals = document.querySelectorAll('.modal.show') as NodeListOf<HTMLElement>;
    modals.forEach(modal => {
      // Exclude templatemodaladd and other modals with data-template-modal attribute
      if (modal && !modal.classList.contains('templatemodaladd') && !modal.hasAttribute('data-template-modal')) {
        if (this.originalBackdropWidth) {
          // Restore original values
          modal.style.left = this.originalBackdropLeft;
          modal.style.width = this.originalBackdropWidth;
          // Restore original height if stored
          if (this.originalBackdropHeight) {
            modal.style.height = this.originalBackdropHeight;
          } else {
            modal.style.removeProperty('height');
          }
          // Restore original top if stored
          if (this.originalBackdropTop) {
            modal.style.top = this.originalBackdropTop;
          } else {
            modal.style.removeProperty('top');
          }
        } else {
          // Fallback: calculate default values if originals weren't stored
          const defaultWidth = viewportWidth * 0.88;
          const defaultLeft = viewportWidth * 0.12;
          modal.style.left = `${defaultLeft}px`;
          modal.style.width = `${defaultWidth}px`;
          modal.style.height = `${backdropHeight}px`;
          modal.style.top = `${headerHeight}px`;
        }
      }
    });
  }
  
  closeTab(name:string) {
    let selectedcomp;
    if(!isNullOrEmpty(name))
    {
     selectedcomp=this.selectedComponents.find(V=>V.displayname===name);
     let index=this.selectedComponents.findIndex(V=>V.displayname===name);
    this.indexnum--;
    this.selectedComponents.splice(index, 1);
    if (this.selectedTabIndex >= this.selectedComponents.length) {
      this.selectedTabIndex = this.selectedComponents.length - 1;
    }
    this.selectedComponents.forEach((element,i) => {
      element.id=i;
    });
    this.service.stopEmitting(selectedcomp.displayname);
  }
  }
  onTimezoneChange(tz: string) {
    this.selectedTimezone = tz;
    this.service.setTimezone(tz);
    this.refreshForTimezone();
    
    // Show timezone change notification
    this.showTimezoneChangeNotification(tz);
  }
    
  refreshForTimezone() {
    this.ngxUiLoaderService.start();
    try {
      // Close all tabs and open default menu
      this.selectedComponents = [];
      this.indexnum = 0;
      this.selectedTabIndex = 0;
      this.SelectedMenus('try it out', false);
    } finally {
      this.ngxUiLoaderService.stopAll();
    }
  }

  showTimezoneNotification() {
    const currentTimezone = this.service.getTimezoneForDisplay();
    this.toastr.success(`Welcome! Your current timezone is set to ${currentTimezone}`, 'Timezone Information', {
      timeOut: 1500,
      positionClass: 'toast-bottom-right'
    });
  }

  showTimezoneChangeNotification(newTimezone: string) {
    this.toastr.success(`Timezone successfully changed to ${newTimezone}`, 'Timezone Updated', {
      timeOut: 500,
      positionClass: 'toast-bottom-right'
    });
  }
}

export interface ICompendium {
  OrganizationID: Number,
  CaseType: String,
  AccountID: Number,
  OptionalAOE: boolean,
  Vendor: String,
  OrganizationName: String,
  AOEs: String
}
export interface Rolepermissionslst {
  PrimaryRoleId: any;
  RoleID: any;
  RoleName:any;
  UserID:any;
  ftpDetailId:string;
  menuslist:any;
  uniqueId:any;
}